import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import moment from "moment";
import { Form, Input, Modal, Select, message, Icon, Button } from "antd";
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    taxPeriod?: string;
    title?: string;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthNote extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const FormItem = Form.Item;
        const Option = Select.Option;
        const { title } = this.props;
        const currentMonth = this.props.taxPeriod ? moment(this.props.taxPeriod).format('YYYY年MM月') : '';
        const currentMonthValue = this.props.taxPeriod ? moment(this.props.taxPeriod).format('YYYY-MM') : '';
        const lastMonth = this.props.taxPeriod ? moment(this.props.taxPeriod).subtract(1, 'month').format("YYYY年MM月") : '';
        const lastMonthValue = this.props.taxPeriod ? moment(this.props.taxPeriod).subtract(1, 'month').format("YYYY-MM") : '';
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }
        };
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                title={<span><span >当前税款所属期为{currentMonth}，请确认一致 </span></span>}
                visible={true}
                onCancel={this.handleCancel}
                onOk={this.handleConfirm}
                footer={[
                    <Button key="back" onClick={this.handleCancel}>
                        取消操作
                    </Button>,
                    <Button key="submit" type="primary" onClick={this.handleConfirm}>
                        继续认证
                    </Button>,
                ]}
            >
                <Form>
                    <div>
                        <Icon style={{ color: 'red' }} type="exclamation-circle" /> 
                        <span style={{color:'red'}}> 当前所属期认证的发票不支持取消认证，认证前请确认当期所勾选的发票数量！</span>
                    </div>
                    <FormItem
                        label={`所属税期`}
                        {...formItemLayout}
                        className='hide'
                    >
                        {getFieldDecorator("invoicePeriod", {
                            initialValue: currentMonthValue
                        })(
                            <Select allowClear={true} style={{ width: 280 }}>
                                <Option value={currentMonthValue} >
                                    {currentMonth}
                                </Option>
                                <Option value={lastMonthValue}>
                                    {lastMonth}
                                </Option>
                            </Select>
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label="备注信息">
                        {getFieldDecorator("batchNote", {
                            rules: [
                                {
                                    message: "不支持特殊字符",
                                    pattern: /^[A-Za-z0-9-_,.()！!‘'\u4e00-\u9fa5\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u3001\uff1f\u300a\u300b\s]+$/,
                                }
                            ]
                        })(
                            <Input
                                type="text"
                                style={{ width: 280 }}
                                maxLength={199}
                            />
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
    private handleConfirm = () => {
        this.props.form.validateFields((err, values) => {
            const data = {
                incomeInvoiceBizIdList: this.modulesState.draftedInvoiceId,
                batchNote: values["batchNote"],
                invoicePeriod: values["invoicePeriod"],
                authType: this.modulesState.authType
            };
            if (values['invoicePeriod']) {
                ModulesAction.handleCommit(data);
            } else {
                message.info('请选择税期');
            }
        });
    }
    private handleCancel = () => {
        this.modulesState.authNoteDisplay = false;
        this.setModulesState();
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.Auth.Note.tsx